import { useLocation, useNavigate } from "react-router-dom";
import ButtonSlideMenu from "./ButtonSlideMenu";
import { GALLERY_TITLE } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { Album } from "../../assets/svg/MenuIcons";
import { ROUTE_GALLERY } from "../../utils/constants";

const ButtonOpenGallery = ({ onTabletLinkClick = () => {} }) => {
  const { t } = useTranslationApp();
  const navigate = useNavigate();
  const location = useLocation();

  const onOpenGallery = () => {
    onTabletLinkClick();

    if (location.pathname === ROUTE_GALLERY) {
      return;
    }

    navigate(ROUTE_GALLERY, {
      state: { galleryBackgroundLocation: location },
    });
  };

  return (
    <ButtonSlideMenu
      id="button-open-gallery"
      menu={{ link: ROUTE_GALLERY, disabledSelectedStyle: true }}
      startIcon={<Album className="w-5 h-5" />}
      onClick={onOpenGallery}
    >
      {t(GALLERY_TITLE)}
    </ButtonSlideMenu>
  );
};

export default ButtonOpenGallery;
